export const URI_NOT_FOUND = '404';
